import React, { useEffect, useState } from 'react';
import {
  deleteSingleArtisanPublicInquiryAction,
  getPendingPublicInquiriesAction
} from '../../../../modules/artisanModeration/publicInquiry/Actions';

import {
  pendingArtisansPublicInquirySelector,
  pendingArtisansPublicInquiryAsListSelector,
  pendingArtisansPublicInquiryCountSelector,
  pendingArtisansPublicInquiryIsLoadingSelector
} from '../../../../modules/artisanModeration/publicInquiry/Selectors';

import { connect } from 'react-redux';

import List from '../../../../components/Lists/List';
import ListItem from '../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import getLangData from '../../../../utils/getLangData';

const PendingArtisansList = props => {
  const {
    publicInquiries,
    publicInquiriesIsLoading,
    getPublicInquiries,
    publicInquiriesCount,
    deleteArtisanPublicInquiry
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    getPublicInquiries({ size, offset, filterBy: [{ rejected: false }] });
  }, [getPublicInquiries]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (publicInquiries.length >= publicInquiriesCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getPublicInquiries({
      size,
      offset: publicInquiries.length,
      filterBy: [{ rejected: false }]
    });
  };

  const dataLength =
    publicInquiries.length <= publicInquiriesCount
      ? publicInquiries.length
      : publicInquiriesCount;

  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={fetchMore}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          isLoading={publicInquiriesIsLoading}
          header={{ items: [getLangData().general_words.title], actions: ['View', 'Delete'] }}
          items={publicInquiries}
        >
          <table className='table'>
            <tbody>
              {publicInquiries.map(({ moderationId, message, title, _id }) => {
                return (
                  <ListItem
                    type='multi'
                    data={[title]}
                    key={_id}
                    viewLink={`/artisans-moderation/public-inquiry/${_id}`}
                    onDelete={() =>
                      deleteArtisanPublicInquiry({
                        _id,
                        url: `public-artisan-inquiry-staging/reject`
                      })
                    }
                  >
                    {console.log(publicInquiries)}
                  </ListItem>
                );
              })}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = state => ({
  publicInquiries: pendingArtisansPublicInquirySelector(state),
  publicInquiriesIsLoading: pendingArtisansPublicInquiryIsLoadingSelector(
    state
  ),
  publicInquiriesCount: pendingArtisansPublicInquiryCountSelector(state)
});

export default connect(mapStateToProps, {
  getPublicInquiries: getPendingPublicInquiriesAction,
  deleteArtisanPublicInquiry: deleteSingleArtisanPublicInquiryAction
})(PendingArtisansList);
